import { CSSProperties, FC } from 'react';
import { Controller, Control } from 'react-hook-form';
import { Input } from 'antd';
import { ErrorText } from '../Elements';
import FormLabel from './FormLabel';

const { TextArea } = Input;

interface InputFieldProps {
  label?: string;
  subLabel?: string;
  placeholder?: string;
  control: any;
  name: string;
  error?: string;
  readonly?: boolean;
  disabled?: boolean;
  variant?: 'outlined' | 'borderless' | 'filled';
  size?: 'large' | 'middle' | 'small';
  formDirection?: 'row' | 'column';
  required?: boolean;
  showCount?: boolean;
  maxLength?: number;
  inputStyle?: CSSProperties;
  rows?: number;
  autoSize?: boolean | { minRows?: number; maxRows?: number };
}

const TextAreaField: FC<InputFieldProps> = ({
  name,
  control,
  label,
  subLabel,
  placeholder,
  variant = 'outlined',
  readonly = false,
  disabled = false,
  error,
  size = 'middle',
  formDirection = 'column',
  required = false,
  showCount = true,
  maxLength = 500,
  inputStyle,
  rows,
  autoSize = { minRows: 3, maxRows: 8 },
}) => {
  const errorStatus = error ? 'error' : undefined;
  return (
    <div className={`form-control ${formDirection}`}>
      {label && (
        <FormLabel required={required} label={label} subLabel={subLabel} />
      )}
      <div className="input-containter">
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <TextArea
              {...field}
              readOnly={readonly}
              variant={variant}
              placeholder={placeholder}
              status={errorStatus}
              size={size}
              disabled={disabled}
              showCount={showCount}
              maxLength={maxLength}
              rows={rows}
              autoSize={autoSize}
              styles={{
                textarea: { lineHeight: 1.6, fontSize: 13, ...inputStyle },
              }}
            />
          )}
        />
        {error && <ErrorText error={error} />}
      </div>
    </div>
  );
};

export default TextAreaField;
